"use client";
import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

export default function DemoRequestsPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  // 📥 Fetch Demo Requests
  const fetchRequests = async () => {
    try {
      const q = query(
        collection(db, "demoRequests"),
        orderBy("createdAt", "desc")
      );

      const snapshot = await getDocs(q);

      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setRequests(data);
    } catch (error) {
      console.error("Error fetching demo requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto shadow-lg rounded-2xl p-6">

        {/* 🔷 Heading */}
        <h2 className="text-2xl font-bold mb-6 text-gray-800">
          Demo Requests
        </h2>

        {/* ⏳ Loading */}
        {loading ? (
          <p className="text-center text-gray-500 py-10">
            Loading demo requests...
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200 rounded-xl overflow-hidden">

              {/* 🧠 Head */}
              <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
                <tr>
                  <th className="px-4 py-3 border">Name</th>
                  <th className="px-4 py-3 border">Phone</th>
                  <th className="px-4 py-3 border">Course</th>
                  <th className="px-4 py-3 border">Message</th>
                  <th className="px-4 py-3 border">Coupon</th>
                  <th className="px-4 py-3 border">Status</th>
                  <th className="px-4 py-3 border">Date</th>
                </tr>
              </thead>

              {/* 📊 Body */}
              <tbody>
                {requests.length === 0 ? (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-6 text-gray-500"
                    >
                      No demo requests found
                    </td>
                  </tr>
                ) : (
                  requests.map((req) => (
                    <tr
                      key={req.id}
                      className="hover:bg-gray-50 transition"
                    >
                      {/* NAME */}
                      <td className="px-4 py-3 border font-medium text-gray-800">
                        {req.name}
                      </td>

                      {/* PHONE */}
                      <td className="px-4 py-3 border text-blue-600">
                        {req.phone}
                      </td>

                      {/* COURSE */}
                      <td className="px-4 py-3 border text-gray-700">
                        {req.course || "-"}
                      </td>

                      {/* MESSAGE */}
                      <td className="px-4 py-3 border text-gray-600 max-w-xs truncate">
                        {req.message || "-"}
                      </td>

                      {/* 🔥 COUPON */}
                      <td className="px-4 py-3 border text-sm">
                        {req.couponCode ? (
                          <div className="flex flex-col">
                            <span className="font-mono text-blue-600">
                              {req.couponCode}
                            </span>
                            <span className="text-xs text-gray-500">
                              {req.couponName}
                            </span>
                          </div>
                        ) : (
                          <span className="text-gray-400 text-xs">
                            No Referral
                          </span>
                        )}
                      </td>

                      {/* STATUS */}
                      <td className="px-4 py-3 border">
                        <span
                          className={`px-3 py-1 text-xs rounded-full font-medium ${req.status === "new"
                              ? "bg-green-100 text-green-700"
                              : "bg-gray-200 text-gray-700"
                            }`}
                        >
                          {req.status}
                        </span>
                      </td>

                      {/* DATE */}
                      <td className="px-4 py-3 border text-sm text-gray-500">
                        {req.createdAt
                          ? new Date(
                            req.createdAt.seconds * 1000
                          ).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>

            </table>
          </div>
        )}
      </div>
    </div>
  );
}